import axios from "axios";
import { toast } from "react-toastify";

export const clientApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  validateStatus: (status) => status < 400,
});

export const refreshApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshRequest = await refreshApi.post("/auth/token/refresh");

        if (refreshRequest.status === 200) {
          window.localStorage.setItem(
            "availabilityTracker",
            JSON.stringify({
              accessTokenExpire: refreshRequest.data.access_token_expire,
              refreshTokenExpire: refreshRequest.data.refresh_token_expire,
              user: refreshRequest.data,
            })
          );
          return clientApi(originalRequest);
        }
        window.location.href = "/login";
      } catch (err) {
        window.location.href = "/login";
      }
    } else {
      throw error;
    }
  }
);

export const makeRequest = (
  url,
  method,
  payload = null,
  shouldReRaise = false,
  setError = null
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const data = await clientApi(url, {
        method,
        data: payload,
      });
      resolve(data?.data);
    } catch (error) {
      if (error?.response?.status >= 500) {
        toast.error("Internal Server Error. Please try again later.");
        return;
      }
      if (error?.code === "ERR_BAD_REQUEST") {
        const data = error.response.data;
        if (Array.isArray(data?.detail)) {
          error.response.data.detail.forEach((err) => {
            if (setError) {
              setError(err.loc[err.loc.length - 1], { message: err.msg });
            }
          });
        } else if (typeof data.detail === "object") {
          Object.keys(data.detail).map((i) =>
            setError(i, { message: data.detail[i] })
          );
        } else {
          toast.error(data?.detail);
        }
      }
      if (shouldReRaise) {
        reject(error.response);
      }
    }
  });
};
